import store from '@/store';
import { flowgoGetRequest, flowgoPostRequest, flowgoDeleteRequest } from '@/util/kpis';

export default {
  async createKnowledgeFile(details) {
    const token = store.state.user.sessionClient.access_token;
    const body = {
      addedByName: details.addedByName,
      fileName: details.fileName,
      uploadedFileUrl: details.uploadedFileUrl,
    };
    const apiResponse = await flowgoPostRequest('/api/createKnowledgeFile', body, {
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
    });
    return apiResponse?.data?.response || apiResponse;
  },

  // Default fetch - all files
  async getAllKnowledgeFiles() {
    const token = store.state.user.sessionClient.access_token;
    const apiResponse = await flowgoGetRequest('/api/getKnowledgeFiles', {
      headers: { Authorization: 'Bearer ' + token },
    });
    return {
      items: apiResponse?.data?.response?.items || [],
      total: apiResponse?.data?.response?.total || 0,
    };
  },

  // Search fetch - filtered files
  async searchKnowledgeFiles(filters = {}) {
    const token = store.state.user.sessionClient.access_token;
    const queryParams = new URLSearchParams();
    if (filters.search) queryParams.append('search', filters.search);
    if (filters.statusIndex !== undefined) queryParams.append('statusIndex', filters.statusIndex);
    if (filters.includeDeleted !== undefined) queryParams.append('includeDeleted', filters.includeDeleted);

    const url = '/api/getKnowledgeFiles' + (queryParams.toString() ? '?' + queryParams.toString() : '');
    const apiResponse = await flowgoGetRequest(url, {
      headers: { Authorization: 'Bearer ' + token },
    });
    return {
      items: apiResponse?.data?.response?.items || [],
      total: apiResponse?.data?.response?.total || 0,
    };
  },

  async deleteKnowledgeFile(fileId) {
    const token = store.state.user.sessionClient.access_token;
    const data = { _id: fileId };
    const apiResponse = await flowgoDeleteRequest('/api/deleteKnowledgeFile', {
      data,
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
    });
    return apiResponse?.data?.response || apiResponse;
  },
};
